import { render, staticRenderFns } from "./TeachingAdminNewForm.vue?vue&type=template&id=f8a15d72"
import script from "./TeachingAdminNewForm.vue?vue&type=script&lang=js"
export * from "./TeachingAdminNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports